<script>
  import { onMount, tick } from 'svelte';
  import Flipper from '~/components/Flipper.svelte';
  import { delay } from '~/animations/utils.svelte';
  import Tile from '~/board/Tile.svelte';
  import WizardContext, { wizard } from './WizardContext.svelte';

  let letter = 'AB';
  let selected = false;

  onMount(() => {
    animate();
  });

  const animate = async () => {
    while (true) {
      await delay(2000);
      selected = true;
      await tick();
      letter = letter === 'AB' ? 'BA' : 'AB';
      await delay(1000);
      selected = false;
    }
  };
</script>

<WizardContext>
  <div class="container">
    <!--
    <div class='pointer'>
      <Pointer size={36} stroke='1px solid black' />
    </div>-->
    <div class="tile-container" use:wizard>
      <Flipper key={letter}>
        <Tile
          {selected}
          dragging={selected}
          tile={{ id: 1, letter, points: 4 }}
        />
      </Flipper>
    </div>
  </div>
</WizardContext>

<style lang="scss">
  .container {
    position: relative;
    width: 48px;
    height: 48px;
    // & .pointer {
    //   position: absolute;
    //   z-index: 800;
    //   top: 4;
    //   left: 4;
    //   animation: move-pointer 2s infinite;
    //   animation-fill-mode: both;
    // }
  }
  .tile-container {
    display: grid;
    width: 48px;
    height: 48px;
    & :global(.tile) {
      font-size: 20px;
    }
  }

  @keyframes move-pointer {
    0% {
      transform: translate(100px, 100px);
    }
    50% {
      transform: translate(80px, 80px);
    }
    60% {
      transform: translate(80px, 80px);
    }
    0% {
      transform: translate(100px, 100px);
    }
  }
</style>
